import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {
  editPubmatic,
  loadPubmaticBuyers,
  loadPubmaticViewModel,
  pubmaticBuyersLoaded,
  pubmaticViewModelLoaded
} from './pubmatic-state';
import {catchError, debounceTime, exhaustMap, filter, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import {PubmaticClientService} from './pubmatic-client.service';
import {NotificationService} from '../../../../utils/notification-service';
import {errorHappened} from '../../../../app.types';
import {of} from 'rxjs';
import {loadInitialConfig} from '../../../../store/global.actions';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class PubmaticEffects {

  loadModel$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadPubmaticViewModel),
      mergeMap((value) =>
        this.client.getById(value.pubmaticExternalId)
          .pipe(
            map(result => pubmaticViewModelLoaded({model: result}))))
    ));


  loadFromInitialConfigLoad$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadInitialConfig),
      filter(value => environment.env !== 'e2e'),
      switchMap((value) => of(loadPubmaticBuyers()))));

  loadBuyers$ = createEffect(() => this.actions$
    .pipe(
      ofType(loadPubmaticBuyers),
      debounceTime(400),
      exhaustMap((value) =>
        this.client.getBuyers()
          .pipe(
            exhaustMap(result => of(pubmaticBuyersLoaded({buyers: result}))),
            catchError(err => of(errorHappened({error: {message: err.message}})))))
    ));

  editModel$ = createEffect(() => this.actions$
    .pipe(
      ofType(editPubmatic),
      mergeMap(({request}) =>
        this.client.update(request)
          .pipe(
            map(result => loadPubmaticViewModel({pubmaticExternalId: result.id})),
            tap(result => this.notificationService.success(`Successfully updated pubmatic entry=${result.pubmaticExternalId}`)),
            catchError(err => of(errorHappened({error: {message: err.message}})))
          ))
    ));

  constructor(private actions$: Actions, private client: PubmaticClientService, private notificationService: NotificationService) {
  }


}
